import React, { useState, useEffect } from 'react';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Alert from '~/commons/components/Alert.jsx';
import Header from '../../layout/Header.jsx';
import ListExchangeRates from '../../lists/ListExchangeRates.jsx';

const PageExchangeRates = () => {
  const [res, req] = useHttpStatus();
  const [show, setShow] = useState(false);

  useEffect(
    () => (res.payload ? setShow(true) : undefined),
    [res],
  );

  return (
    <div>
      <Header>Exchange Rates</Header>
      {show && (
        <Alert
          onClose={() => setShow(false)}
          theme={
            res?.payload?.success ? 'success' : 'danger'
          }>
          {res?.payload?.message}
        </Alert>
      )}
      <ListExchangeRates
        sync={() => req({
          url: '/api/core/exchange-rates/sync',
          method: 'POST',
        })
        }
        res={res}
      />
    </div>
  );
};

export default PageExchangeRates;
